/**
 * Zebedo Cart Utilities
 * Reusable AJAX cart functions for adding items and opening the cart drawer
 */

window.ZebedoCart = window.ZebedoCart || {};

/**
 * Add an item to the cart and optionally open the cart drawer
 * @param {string|number} variantId - The variant ID to add
 * @param {number} quantity - Quantity to add (default: 1)
 * @param {boolean} openDrawer - Whether to open the cart drawer after adding (default: true)
 * @param {Object} properties - Optional line item properties
 * @returns {Promise<Object>} - The cart response data
 */
window.ZebedoCart.updateCartIconCount = function (count) {
  const cartLink = document.getElementById("cart-icon-bubble");
  if (!cartLink) return;

  cartLink.querySelectorAll(".cart-count-bubble").forEach((el) => el.remove());

  let badge = cartLink.querySelector(".zebedo-header__cart-count");

  if (count > 0) {
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "zebedo-header__cart-count";
      badge.setAttribute("aria-live", "polite");
      cartLink.appendChild(badge);
    }
    badge.textContent = count;
    badge.hidden = false;
    badge.style.display = "";
  } else if (badge) {
    badge.hidden = true;
    badge.style.display = "none";
  }
};

window.ZebedoCart.addToCart = async function(variantId, quantity = 1, openDrawer = true, properties = {}) {
  const body = {
    items: [{
      id: parseInt(variantId),
      quantity: quantity
    }]
  };

  // Add properties if provided
  if (Object.keys(properties).length > 0) {
    body.items[0].properties = properties;
  }

  try {
    // Add item to cart
    const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!addResponse.ok) {
      const errorData = await addResponse.json();
      throw new Error(errorData.description || 'Failed to add item to cart');
    }

    const cartData = await addResponse.json();

    // Find the cart drawer (zebedo or default)
    const cartDrawer = document.querySelector('zebedo-cart-drawer') || document.querySelector('cart-drawer');
    
    if (cartDrawer) {
      // Determine the correct section ID based on the drawer type
      const sectionId = cartDrawer.tagName.toLowerCase() === 'zebedo-cart-drawer' 
        ? 'zebedo-cart-drawer' 
        : 'cart-drawer';

      // Fetch updated sections
      const sectionsResponse = await fetch(
        window.Shopify.routes.root + `?sections=${sectionId}`
      );
      const sections = await sectionsResponse.json();

      // Update the cart drawer content
      if (sections[sectionId]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections[sectionId], 'text/html');
        const newDrawerContent = doc.querySelector(cartDrawer.tagName.toLowerCase());
        
        if (newDrawerContent) {
          cartDrawer.innerHTML = newDrawerContent.innerHTML;
        }
      }

      window.ZebedoCart.updateCartIconCount(cartData.item_count);

      // Open the drawer if requested
      if (openDrawer) {
        if (typeof window.zebedoOpenCart === "function") {
          window.zebedoOpenCart();
        } else if (typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      }
    } else {
      // No cart drawer found, redirect to cart page
      if (openDrawer) {
        window.location = window.routes?.cart_url || '/cart';
      }
    }

    // Dispatch custom event for other components to listen to
    document.dispatchEvent(new CustomEvent('zebedo:cart:updated', {
      detail: { cartData }
    }));

    return cartData;

  } catch (error) {
    console.error('ZebedoCart: Error adding to cart:', error);
    
    // Dispatch error event
    document.dispatchEvent(new CustomEvent('zebedo:cart:error', {
      detail: { error: error.message }
    }));

    throw error;
  }
};

/**
 * Update cart icon bubble count
 * Call this after any cart modification to ensure the icon is up to date
 */
window.ZebedoCart.updateCartBubble = async function() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js");
    const cart = await response.json();
    window.ZebedoCart.updateCartIconCount(cart.item_count);
  } catch (error) {
    console.error("ZebedoCart: Error updating cart bubble:", error);
  }
};

/**
 * Open the cart drawer without adding items
 */
window.ZebedoCart.openDrawer = function() {
  if (typeof window.zebedoOpenCart === "function") {
    window.zebedoOpenCart();
    return;
  }

  const cartDrawer = document.querySelector('zebedo-cart-drawer') || document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    cartDrawer.open();
  }
};

/**
 * Close the cart drawer
 */
window.ZebedoCart.closeDrawer = function() {
  const cartDrawer = document.querySelector('zebedo-cart-drawer') || document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.close === 'function') {
    cartDrawer.close();
  }
};
